[
  {
    "id": 1,
    "view_id": 1,
    "label": "What is your role in the lab/what is your title?",
    "placeholder": "Choose one",
    "format": "listbox",
    "error": "Please select your role"
  },
  {
    "id": 2,
    "view_id": 1,
    "label": "Is your lab currently experiencing any of the following challenges?",
    "kicker": "Select all that apply:",
    "format": "checkbox",
    "error": "Please select all that apply"
  },
  {
    "id": 3,
    "view_id": 1,
    "label": "Which of the following operational challenges have you observed in your work environment?",
    "kicker": "Select all that apply:",
    "format": "checkbox",
    "error": "Please select all that apply"
  },
  {
    "id": 4,
    "view_id": 2,
    "label": "In today's rapidly changing diagnostic landscape, how would you assess your lab's readiness to adapt current workflows and staffing models to new microbiology technologies?",
    "kicker": "Select one:",
    "format": "radio",
    "error": "Please select one"
  },
  {
    "id": 5,
    "view_id": 2,
    "label": "Have you introduced any new technologies into your laboratory within the past 2-5 years, and if yes, how satisfied are you with their implementation and outcomes?",
    "kicker": "Select one:",
    "format": "radio",
    "error": "Please select one"
  },
  {
    "id": 6,
    "view_id": 2,
    "label": "Have you worked with or considered working with a lab consultant in the past?",
    "kicker": "Select one:",
    "format": "radio",
    "error": "Please select one"
  },
  {
    "id": 7,
    "view_id": 3,
    "label": "How confident are you that your lab is currently adhering to the most up-to-date guidelines, regulations, and best practices?",
    "kicker": "Select one:",
    "format": "radio",
    "error": "Please select one"
  },
  {
    "id": 8,
    "view_id": 3,
    "label": "When considering the future of your lab, which of the following are your biggest concerns?",
    "kicker": "Select all that apply:",
    "format": "checkbox",
    "error": "Please select all that apply"
  },
  {
    "id": 9,
    "view_id": 3,
    "label": "Are you or your facility currently involved in efforts to accomplish the following goals?",
    "kicker": "Select all that apply:",
    "format": "checkbox",
    "error": "Please select all that apply"
  },
  {
    "id": 10,
    "view_id": 4,
    "label": "Enter your email",
    "error": "Please enter an email"
  }
]